:host {
  @apply flex flex-col bg-foreground-1;
  --calcite-list-item-icon-color: theme("colors.brand");
}

:host([filter-hidden]),
:host([closed]) {
  @apply hidden;
}

.wrapper--bordered {
  border-block-end: 1px solid var(--calcite-color-border-3);
}

@include disabled();

.container {
  @apply bg-foreground-1
  box-border
  flex
  flex-1;
  * {
    @apply box-border;
  }
}

.container--hover:hover {
  @apply bg-foreground-2 cursor-pointer;
}

.container:active {
  @apply bg-foreground-1;
}

.container--border {
  border-inline-start-width: theme("borderWidth.4");
  border-inline-start-style: solid;
}

.container--border-selected {
  border-inline-start-color: theme("colors.brand");
}

.container--border-unselected {
  border-inline-start-color: transparent;
}

.container:hover {
  &.container--border-unselected {
    @apply border-color-1;
  }
}

.nested-container {
  @apply hidden flex-col
    border-solid
    border-0
    border-color-3;

  margin-inline-start: var(--calcite-list-item-spacing-indent, theme("spacing.6"));
}

.nested-container--open {
  @apply flex;
}

.content-container {
  @apply text-color-2
    select-none
    flex
    flex-auto
    font-normal
    items-stretch
    p-0;
}

tr,
td {
  @apply focus-base;
}

tr {
  @apply relative;
}

tr:focus,
td:focus {
  @apply focus-inset;
}

.content,
.custom-content {
  @apply text-n2-wrap
    flex
    flex-auto
    flex-col
    justify-center
    px-3
    py-2;
}

.label,
.description,
.content-bottom {
  @apply text-n2 word-break font-sans font-normal;
  &:only-child {
    @apply m-0 py-1;
  }
}

.label {
  @apply text-color-1;
}

:host([selected]) .label {
  @apply font-medium;
}

.description {
  @apply text-color-3 mt-0.5;
}

:host([selected]) .description {
  @apply text-color-2;
}

.content-start {
  @apply justify-start;
}

.content-end {
  @apply justify-end;
}

.content-start,
.content-end {
  @apply flex-auto;

  ::slotted(calcite-icon) {
    @apply self-center mx-3;
  }
}

.content-bottom {
  @apply flex flex-col;
}

.content-container--has-center-content .content-start,
.content-container--has-center-content .content-end {
  @apply flex-initial;
}

.selection-container {
  @apply flex px-3 py-0;
  color: theme("borderColor.color.input");
}

.selection-container--single {
  color: transparent;
}

:host(:not([disabled]):not([selected])) .container:hover .selection-container--single {
  color: theme("borderColor.color.1");
}

:host([selected]:hover) .selection-container,
:host([selected]:hover) .selection-container--single,
:host([selected]) .selection-container {
  color: var(--calcite-list-item-icon-color);
}

.open-container {
  color: theme("textColor.color.3");
}

:host(:not([disabled])) .container:hover .open-container {
  color: theme("textColor.color.1");
}

.actions-start,
.actions-end,
.content-start,
.content-end,
.selection-container,
.drag-container,
.open-container {
  @apply flex items-center;

  calcite-action,
  calcite-handle {
    @apply self-stretch;
  }
}

.open-container,
.selection-container {
  @apply cursor-pointer;
}

.actions-start,
.actions-end {
  @apply p-0 relative;
  ::slotted(calcite-action),
  ::slotted(calcite-action-menu),
  ::slotted(calcite-handle),
  ::slotted(calcite-dropdown) {
    @apply self-stretch;

    color: inherit;
  }
}

tr:focus {
  .actions-start,
  .actions-end {
    inset-block: theme("spacing[0.5]");
    .close,
    ::slotted(calcite-action),
    ::slotted(calcite-action-menu),
    ::slotted(calcite-handle),
    ::slotted(calcite-dropdown) {
      block-size: calc(100% - theme("spacing[1]"));
    }
  }

  &::after,
  &::before {
    @apply absolute;
    content: "";
    inline-size: theme("spacing[0.5]");
    z-index: theme("zIndex.header");
    background-color: theme("colors.brand");
    inset-block: 0;
  }
  &::before {
    inset-inline-start: 0;
  }
  &::after {
    inset-inline-end: 0;
  }
}

.container--border:focus::before {
  display: none;
}

::slotted(calcite-list:empty) {
  @apply border-t-0;
}

@include base-component();
